'use strict';

angular.module('clientDashboardApp').directive('tutorials', ['$log', '$location', '$timeout', '$interval','tutorialService', function ($log,$location,$timeout,$interval,tutorialService) {
  return {
    restrict: 'E',
    transclude: false,
    replace: true,
    template:   '<div ng-if="!ttl.disableTTL" class="ttl-wrapper ttl-active-layer" ng-class="{ttlOn: ttl.tutorialActive, ttlOff: !ttl.tutorialActive}">\
                  <div class="ttl-transparency"></div>\
                  <div id="button-tutorial" class="button-tutorial view-tutorial" ng-class="{disable: ttl.disable}">\
                    <span ng-click="beginTutorial()"><i class="fas fa-info-circle fa-3"></i></span>\
                    <span class="button-ttl-nav-links">\
                      <a href="" ng-click="prev()" ng-disabled="ttl.onFirstStep">Back</a>\
                      <a href="" ng-click="next()" ng-disabled="ttl.onLastStep">Next</a>\
                      <a href="" ng-click="beginTutorial()">Start Over</a>\
                      <a href="" ng-click="exitTutorial()">Exit Tutorial</a>\
                    </span>\
                  </div>\
                 </div>',
    link: function (scope) {

      scope.btnAnim = null;

      scope.ttl = {
        disableTTL: true,
        tutorialActive: false,
        errorFlag: false,
        lastItem: null,
        onFirstStep: true,
        onLastStep: false,
        pageReady: false,
        tourWindowMode: null,
        resizing: false,
        btnOffset: null,
        urlKey: null,
        title: null,
        disable: false
      };

      if (!scope.ttl.disableTTL) {

        scope.detectLocationString = function () {

          scope.ttl.urlKey = $location.url();
          var endUrl = scope.ttl.urlKey.indexOf('?');
          if (endUrl >= 0) {
            scope.ttl.urlKey = scope.ttl.urlKey.substring(1, endUrl);
          } else {
            scope.ttl.urlKey = scope.ttl.urlKey.substring(1, scope.ttl.urlKey.length);
          }

          var titleArr = scope.ttl.urlKey.split("");
          scope.ttl.title = "";
          for (var x in titleArr) {
            if (x == 0) {
              scope.ttl.title += titleArr[x].toUpperCase();
            }
            else {
              scope.ttl.title += titleArr[x];
            }
          }

          var tmp = scope.ttl.title.indexOf('/');
          if (tmp >= 0) {
            scope.ttl.title = scope.ttl.title.substring(0, tmp);
          }

          if (scope.ttl.urlKey.indexOf('/') >= 0) {
            scope.ttl.urlKey = scope.ttl.urlKey.replace("/", "_");
          }

        }

        scope.detectWindowSize = function () {
          scope.windowSize = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }

        scope.setPlacement = function (side) {
          var res = scope.windowSize < 992 ? "top" : side;
          return res;
        }

        scope.detectWindowSize();
        scope.detectLocationString();

        scope.ttlPages = {

          snapshot: {

            id: "snapshot_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "ttl-item-location-dropdown",
                placement: "left",
                title: "Location Dropdown",
                content: "<p>Use the location drop-down to select which location or group of locations your reporting reflects.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-reviews",
                placement: "right",
                title: "Reviews",
                content: "<p>This shows you how many new reviews have been added in the last 30 days, as well as all time.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-social-mentions",
                placement: "right",
                title: "Social Mentions",
                content: "<p>This shows you how many times your location(s) have been talked about (mentioned) on social media in the last 30 days, and for all time.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-listings",
                placement: "right",
                title: "Listings",
                content: "<p>Here you will see the listings that have been added to providers (Yelp, Google, etc) in the last 30 days, and what percentage of your total locations are listed on Google Maps</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-rankings",
                placement: "left",
                title: "Rankings",
                content: "<p>This shows the number of stores that are listed on page 1 of Google web search results for your primary category, and what percentage of stores appear before page 5</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }

              },
              {
                target: "ttl-item-map-widget",
                placement: "top",
                yOffset: 30,
                title: "Performance Summary Map",
                content: "<p>The map gives you a high level view of how regions are performing based on their average review ratings and allows you to drill down to any individual store.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-overall-score",
                placement: "left",
                title: "LBV Score",
                content: "<p>Our internal algorithm rates your locations factoring in reviews, listings, social presence, and more. Visit the Workflow section for information on how to improve this.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-summary-reports",
                placement: "left",
                title: "Summary Reports",
                content: "<p>After selecting a single location from the Location drop-down at the top of the page, you can generate a downloadable rollup report that summarizes a location by month.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-negative-reviews",
                placement: "left",
                title: "Negative Reviews",
                content: "<p>Here you will find the most recent negative reviews for your location.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-positive-reviews",
                placement: "left",
                title: "Positive Reviews",
                content: "<p>Here you will find the most recent positive reviews for your location.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              }
            ]
          },

          sentiment: {

            id: "sentiment_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Date and Provider",
                content: "<p>Here you can select a date range and provider to filter Sentiment results.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-graph",
                placement: "right",
                title: "Sentiment Chart",
                content: "<p>Here you can view the sentiment results visually over time</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-raves",
                placement: "left",
                title: "Raves",
                content: "<p>These are the positive sentiments that we have gathered for the date range and providers you specified</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                  //alert('open sentiment reviews');
                  //scope.setSelectedSentimentId(3);
                }
              },
              {
                target: "ttl-item-rants",
                placement: "left",
                title: "Rants",
                content: "<p>These are the negative sentiments that we have gathered for the date range and providers you specified</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                  scope.setSelectedSentimentId(4);
                }

              },
              {
                target: "ttl-item-reviews",
                placement: "top",
                title: "Reviews",
                delay: 1000,
                content: "<p>These are the reviews that contributed to the sentiment you selected.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              }
            ]
          },

          reviews: {

            id: "reviews_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Review Report Options",
                content: "<p>Here you can set report options like report type, date range, and provider to create a report taylored to your needs.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-review-counts",
                placement: "right",
                title: "Review Counts Chart",
                content: "<p>This chart shows the total number of reviews and average rating for your location.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-review-sentiment",
                placement: "right",
                title: "Review Sentiment Chart",
                content: "<p>This chart shows what percentage of reviews have a negative, positive, or neutral review sentiment.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                  //alert('open sentiment reviews');
                  //scope.setSelectedSentimentId(3);
                }
              },
              {
                target: "ttl-item-review-summary",
                placement: "left",
                title: "Review Details",
                content: "<p>Here you will find the details of reviews of the last 3 months and for all time.  You can quickly gauge how your location's recent progress compares against its overall progress.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-last-review",
                placement: "left",
                title: "Provider Review Counts",
                content: "<p>Here you can quickly see how your online reputation varies across providers, and on which sites your location is being talked about the most.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              },
              {
                target: "ttl-item-review-details",
                placement: "top",
                title: "Reviews",
                content: "<p>These are all of the reviews we have gathered for the date range, time period, and providers specified.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                  //scope.prev();
                },
                onNext: function () {
                  scope.updateTtl();
                  //scope.next();
                }
              }
            ]
          },
          chatter: {

            id: "chatter_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Chatter Report Options",
                content: "<p>Here you can set report options like report type, date range, and provider to create a report taylored to your needs.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-total-chatter",
                placement: "right",
                title: "Total Chatter Chart",
                content: "<p>This chart shows the total chatter for your location for the options specified in the previous step.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-social-mentions",
                placement: "left",
                title: "Raves",
                content: "<p>Here you will find the Social Mentions for a location compared against that of local competitors.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-mention-details",
                placement: "top",
                title: "Mentions",
                content: "<p>These are the mentions that we have gathered for the date range and providers you specified</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                }
              }
            ]
          },
          listings: {

            id: "listings_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Date and Provider",
                content: "<p>Here you can set report options like report type, date range, and provider to create a report taylored to your needs.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-listing-summary",
                placement: "left",
                title: "Listing Summary",
                xOffset: -200,
                yOffset: 80,
                content: "<p>This table shows you important details about your listings on the provider sites you selected.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-search-results",
                placement: "top",
                title: "Search Results",
                content: "<p>These are all of the listings found for the date range and providers you specified</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              }
            ]
          },
          rankings: {

            id: "rankings_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Rankings Report Options",
                content: "<p>Here you can set report options like report type, ranking type, date range, and provider to create a report taylored to your needs.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-average-ranking-description",
                placement: "bottom",
                title: "Report Description",
                content: "<p>Here is a description of the current report type.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-average-ranking",
                placement: "top",
                title: "Average Ranking Chart",
                xOffset: 130,
                yOffset: 70,
                content: "<p>This report indicates the average ranking for the keywords selected for your store(s).</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-average-ranking-provider-table",
                placement: "top",
                title: "Keywords",
                content: "<p>Here you can see how your page ranks on various search sites with the keywords provided.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              }
            ]
          },
          media: {

            id: "rankings_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Media Options",
                content: "<p>Here you can set options like listing images and provider to display only the images you want to view.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-media",
                placement: "left",
                yOffset: 70,
                xOffset: 130,
                title: "Media",
                content: "<p>Here you can view images from the specified providers.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                }
              }
            ]
          },
          workflow_tasks: {

            id: "rankings_tour",
            smoothScroll: true,
            onClose: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onEnd: function () {
              $timeout(function () {
                if (!scope.ttl.errorFlag) {
                  scope.markComplete();
                  scope.exitTutorial();
                }
                scope.ttl.errorFlag = false;
              }, 0);
            },
            onError: function () {
              scope.ttl.errorFlag = true;
              $timeout(function () {
                scope.setSelectedSentimentId(4);
              }, 0);
            },
            steps: [
              {
                target: "sidebar",
                placement: "right",
                title: "Workflow Report Options",
                content: "<p>Here you can set report options like report type, providers, task types, and task status to create a report taylored to your needs.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-todo",
                placement: "right",
                title: "To-do",
                content: "<p>This indicates how many to-do items you currently have.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-completed",
                placement: "left",
                title: "Pending Validation",
                content: "<p>This indicates how many items you have completed that are pending validation.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-validated",
                placement: "left",
                title: "Validated",
                content: "<p>This indicates how many items you have completed that have been validated.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              },
              {
                target: "ttl-item-search-results",
                placement: "top",
                title: "Tasks",
                content: "<p>Here is a detailed list of tasks, with information on status, provider, as well as options to hide or change status.</p><hr /><div class='try-it'><i class='fas fa-rocket fa-3'></i><h5>TRY IT</h5><p>Add text here.</p></div><hr />",
                showPrevButton: true,
                onPrev: function () {
                  scope.updateTtl();
                },
                onNext: function () {
                  scope.updateTtl();
                }
              }
            ]
          },
          introMsg: {
            onClose: function () {
              $timeout(function () {
                scope.stopWobble();
              }, 0);
            },
            id: "introMsg",
            smoothScroll: true,
            showNextButton: false,
            steps: [
              {
                target: "button-tutorial",
                placement: "left",
                delay: 1000,
                title: "",
                content: "<p>Welcome to the " + scope.ttl.title + " section.  For a quick overview of this section click here.</p>"
              }
            ]
          }
        };


        scope.hsPlacement = [];

        scope.initWindowMode = function () {
          if (scope.windowSize >= 992) {
            scope.ttl.tourWindowMode = "large";
          }
          else if (scope.windowSize < 992 && scope.windowSize >= 630) {
            scope.ttl.tourWindowMode = "small";
          }
          else {
            scope.ttl.tourWindowMode = "tiny";
          }
        }

        scope.updateBubble = function (id, step, placement, arrowOffset, xOffset) {
          if (placement != "inherit") {
            scope.ttlPages[id].steps[step].placement = placement;
          }
          if (arrowOffset != "inherit") {
            scope.ttlPages[id].steps[step].arrowOffset = arrowOffset;
          }
          if (xOffset != "inherit") {
            scope.ttlPages[id].steps[step].xOffset = xOffset;
          }
        }

        scope.updateHsPositions = function () {

          if (scope.windowSize < 992) {
            for (var ttlPage in scope.ttlPages) {
              for (var step in scope.ttlPages[ttlPage].steps) {
                scope.ttlPages[ttlPage].steps[step].placement = "top";
                if (step < 2) {
                  scope.updateBubble(ttlPage, step, "bottom", "inherit", "inherit");
                }
              }
            }
            if (scope.windowSize >= 630) {
              scope.ttl.tourWindowMode = "small";
              scope.updateBubble("introMsg", 0, "left", 0, 0);
            }
            else {
              scope.ttl.tourWindowMode = "tiny";
              scope.updateBubble("introMsg", 0, "right", 0, 0);
            }
          }
          else {
            for (var ttlPage in scope.ttlPages) {
              for (var step in scope.ttlPages[ttlPage].steps) {
                scope.updateBubble(ttlPage, step, scope.hsPlacement[ttlPage][step], 0, 0);
              }
            }
            scope.ttl.tourWindowMode = "large";
            scope.updateBubble("introMsg", 0, "left", 0, 0);
          }

        }

        scope.copyHsPlacement = function () {
          for (var ttlPage in scope.ttlPages) {
            scope.hsPlacement[ttlPage] = [];
            for (var step in scope.ttlPages[ttlPage].steps) {
              scope.hsPlacement[ttlPage].push(scope.ttlPages[ttlPage].steps[step].placement);
            }
          }

        }

        scope.initScrollMngr = function () {
          $timeout(function () {
            scope.ttl.btnOffset = $('.button-tutorial').offset().top;
            $(window).scroll(function () {
              if (scope.ttl.tourWindowMode == "tiny") {
                var scrolltop = $(window).scrollTop();
                var diff = 53 - scrolltop;
                var top = diff > 0 ? diff : 0;
                $('.ttlOn .button-tutorial').css({"top": top});
              }
            });
          });

        }


        scope.resetBtnPos = function () {
          $('.button-tutorial').css({"top": ""});
        }


        scope.initPlacementManager = function () {

          scope.initWindowMode();
          scope.copyHsPlacement();
          scope.updateHsPositions();
          scope.initScrollMngr();


          //resizeStart handler
          $(window).bind('resizeStart', function () {

            scope.ttl.resizing = true;
            //scope.ttl.lastTourId = hopscotch.getCurrTour().id;
            //scope.ttl.lastTourStep = hopscotch.getCurrStepNum();

          });

          //resizeEnd handler
          $(window).bind('resizeEnd', function () {
            scope.ttl.btnOffset = $('.button-tutorial').offset().top;
            scope.ttl.resizing = false;
            $timeout(function () {
              $(".hopscotch-bubble").removeClass('hide-bubble');
            }, 1000);
          });

          //resize handler
          $(window).resize(function () {
            scope.detectWindowSize();
            if (this.resizeTO) {
              if (scope.windowSize < 992 && scope.windowSize >= 630 && scope.ttl.tourWindowMode != "small") {
                scope.ttl.tourWindowMode = "small";
                $(".hopscotch-bubble").addClass('hide-bubble');
              }
              else if (scope.windowSize < 630 && scope.ttl.tourWindowMode != "tiny") {
                scope.ttl.tourWindowMode = "tiny";
                $(".hopscotch-bubble").addClass('hide-bubble');
              }
              else if (scope.windowSize >= 992 && scope.ttl.tourWindowMode != "large") {
                scope.ttl.tourWindowMode = "large";
                $(".hopscotch-bubble").addClass('hide-bubble');
              }
              clearTimeout(this.resizeTO)
            }
            if (!scope.ttl.resizing) {
              $(this).trigger('resizeStart');
            }
            this.resizeTO = setTimeout(function () {
              $(this).trigger('resizeEnd');
            }, 500);
          });

        }

        scope.initPlacementManager();


        scope.$watch(function () {
          return scope.ttl.tourWindowMode;
        }, function (newValue, oldValue) {

          if (newValue != oldValue) {
            scope.updateHsPositions();
            scope.resetBtnPos();

            if (scope.ttl.tutorialActive) {
              hopscotch.startTour(hopscotch.getCurrTour().id, hopscotch.getCurrStepNum());
            } else if ($('.ttl-wrapper').hasClass('ttl-show-intro')) {
              hopscotch.startTour("introMsg", 0);
            }

          }
        });

        scope.userSettings = tutorialService.getTtlSettings();

        scope.$watch(function () {
          return scope.userSettings;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            tutorialService.updateTtlSettings(scope.userSettings);
          }
        }, true);

        scope.userSettingsChange = function (option) {
          if (option != "skipPages") {
            scope.userSettings[option] = true;
          }
          else {
            scope.userSettings.skipPages.push(scope.ttl.urlKey);
          }
        }


        scope.setIsFirstLast = function (step) {
          if (step == 0) {
            scope.ttl.onFirstStep = true;
          }
          else {
            scope.ttl.onFirstStep = false;
          }
          if (step == scope.ttlPages[scope.ttl.urlKey].steps.length - 1) {
            scope.ttl.onLastStep = true;
          }
          else {
            scope.ttl.onLastStep = false;
          }
        }

        scope.updateTtl = function (id) {

          var currId;
          if (arguments.length == 0) {
            currId = scope.ttlPages[scope.ttl.urlKey].steps[hopscotch.getCurrStepNum()].target;
          }
          else {
            currId = id;
          }

          scope.setIsFirstLast(hopscotch.getCurrStepNum());

          var currItem = $("#" + currId);
          var lastItem = $("#" + scope.ttl.lastItem);
          lastItem.removeClass('ttl-active-item').css({'z-index': '4'});
          currItem.addClass('ttl-active-item');

          $timeout(function () {
            currItem.css({'z-index': '5'});
          }, 0);
          scope.ttl.lastItem = currId;


        }

        scope.next = function () {
          hopscotch.nextStep();
        }

        scope.prev = function () {
          hopscotch.prevStep();
        }

        scope.$watch(function () {
          return scope.loadingReviews;
        }, function (newValue, oldValue) {

          if (!newValue && oldValue) {
            if (scope.ttl.urlKey == "sentiment") {
              $timeout(function () {
                //scope.setInactiveFlag(4);
                //scope.goToTutorialItem(4);
                hopscotch.startTour(scope.ttlPages[scope.ttl.urlKey], 4);
                scope.updateTtl();

              }, 0);
            }
          }
        }, true);

        scope.$watch(function () {
          return scope.ttl.tutorialActive;
        }, function (newValue, oldValue) {

          if (newValue !== oldValue) {

            var ttlClass;
            var zIndex;
            var delay;
            if (scope.ttl.tutorialActive) {
              ttlClass = "ttlOn";
              zIndex = "0";
              delay = 0;
            } else {
              ttlClass = "ttlOff";
              zIndex = "-1";
              delay = 1000;
            }
            $('.cm-main, .navbar').removeClass("ttlOn ttlOff").addClass(ttlClass);
            $timeout(function () {
              $('.ttl-transparency').css({"z-index": zIndex});
            }, delay);
          }
        }, true);

        scope.exitTutorial = function () {

          scope.scrollToTop();
          scope.resetBtnPos();
          scope.userSettingsChange('close');
          scope.ttl.tutorialActive = false;
          hopscotch.endTour();
          $('.ttl-active-item').removeClass('ttl-active-item').css({'z-index': '4'});
          scope.userSettings.seenintroMsg = true;

        }

        scope.introMsg = function () {
          hopscotch.startTour(scope.ttlPages.introMsg, 0);
        }

        scope.openOptOutBox = function () {
          scope.updateTtl('ttl-opt-out');
          hopscotch.endTour();
        }

        scope.scrollToTop = function () {
          $('html,body').animate({
            scrollTop: 0
          }, 1000);
        }

        scope.stopWobble = function () {
          $('.ttl-wrapper').removeClass('ttl-show-intro').addClass('ttl-no-intro');
        }

        scope.beginTutorial = function () {

          if (!scope.ttl.disable) {
            scope.stopWobble();
            if (hopscotch.getCurrTour()) {
              if (hopscotch.getCurrTour().id == "introMsg") {
                hopscotch.endTour();
              }
            }

            scope.ttl.tutorialActive = true;
            $('.cm-main, .navbar').addClass('ttl-active-layer');
            $('#' + scope.ttlPages[scope.ttl.urlKey].steps[0].target).addClass('ttl-active-item');

            hopscotch.startTour(scope.ttlPages[scope.ttl.urlKey], 0);
            scope.updateTtl();
            scope.ttl.lastItem = scope.ttlPages[scope.ttl.urlKey].steps[0].target;
          }

        }

        scope.markComplete = function () {
          if (scope.userSettings.completedTutorials.indexOf(scope.ttl.urlKey) == -1) {
            scope.userSettings.completedTutorials.push(scope.ttl.urlKey);
          }

        }


        if (scope.userSettings.pagesVisited.length > 0) {
          $('.ttl-wrapper').addClass('ttl-no-intro');
        }
        else {
          $('.ttl-wrapper').addClass('ttl-show-intro');
        }


        if (scope.ttl.urlKey === "reviews" || scope.ttl.urlKey === "chatter" || scope.ttl.urlKey === "listings" || scope.ttl.urlKey === "rankings") {

          scope.$watch(function () {
            return scope.reportType;
          }, function (newValue, oldValue) {
            if ((typeof newValue === "string" && newValue !== "summary") || (typeof newValue === "object" && newValue.id != "1")) {
              scope.ttl.disable = true;
              hopscotch.endTour();
              $interval.cancel(scope.btnAnim);
              $('.button-tutorial, .tour-introMsg').removeClass('wobble');
            }
            else {
              scope.ttl.disable = false;
            }
          });

        }

        if (scope.ttl.urlKey === "workflow_scoring") {
          scope.ttl.disable = true;
        }

        if (scope.userSettings.pagesVisited.length == 0) {

          //make sure page content is loaded before displaying tutorial intro
          if (scope.ttl.urlKey === "reviews" || scope.ttl.urlKey === "chatter" || scope.ttl.urlKey === "listings" || scope.ttl.urlKey === "rankings") {
            scope.$watch(function () {
              return scope.loadingResults;
            }, function (newValue, oldValue) {
              if (newValue === false) {
                scope.ttl.pageReady = true;
              }
            });
          }
          else if (scope.ttl.urlKey === "snapshot") {
            var ready = 0;
            scope.$watch(function () {
              return scope.currentLocationGroup;
            }, function (newValue, oldValue) {
              if (newValue) {
                ready++;
              }
            });
            scope.$watch(function () {
              return scope.avgReviewByState;
            }, function (newValue, oldValue) {
              if (newValue) {
                ready++;
              }
            });
            scope.$watch(function () {
              return scope.reviewSummaryByLocation;
            }, function (newValue, oldValue) {
              if (newValue) {
                ready++;
              }
            });
            scope.$watch(function () {
              return ready;
            }, function (newValue, oldValue) {
              if (newValue === 3) {
                scope.ttl.pageReady = true;
              }
            });
          }
          else if (scope.ttl.urlKey === "sentiment") {
            scope.$watch(function () {
              return scope.loadingSummary;
            }, function (newValue, oldValue) {
              if (newValue === false) {
                scope.ttl.pageReady = true;
              }
            });
          }
          else {
            $timeout(function () {
              scope.ttl.pageReady = true;
            }, 1000);

          }

        }

        scope.ttlIntro = function () {
          if (!scope.ttl.disable) {

            var wobbleCount = 0;
            $timeout(function () {
              scope.userSettings.pagesVisited.push(scope.ttl.urlKey);
              $('.button-tutorial').addClass('enter');
              $timeout(function () {
                scope.introMsg();
              }, 1000);
              scope.wobble();
            }, 1000);

            scope.wobble = function () {
              $timeout(function () {
                $('.button-tutorial').addClass('button-visible');
                scope.btnAnim = $interval(function () {
                  if ($('.button-tutorial').hasClass('enter')) {
                    $('.button-tutorial, .tour-introMsg').removeClass('enter');
                  }
                  if (wobbleCount == 12) {
                    $('.button-tutorial, .tour-introMsg').addClass('wobble');
                  }
                  else if (wobbleCount == 13) {
                    $('.button-tutorial, .tour-introMsg').removeClass('wobble');
                  }
                  wobbleCount++;
                  if (wobbleCount > 15) {
                    wobbleCount = 0;
                  }
                }, 500, 0);
              }, 1000);

            };
          }
          else {
            $('.button-tutorial').addClass('button-visible');
          }
        }

        scope.$watch(function () {
          return scope.avgReviewByState;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
          }
        });

        scope.$watch(function () {
          return scope.ttl.pageReady;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            if (newValue === true) {
              $timeout(function () {
                scope.ttlIntro();
              }, 100);

            }
          }
        });

        scope.$on('$destroy', function () {
          hopscotch.endTour();
        });


      }
    }
  }
}
])
;
